'use client';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { AnimatePresence, motion } from 'framer-motion';
import { Cookie } from 'lucide-react'; // Add this import
import { useEffect, useState } from 'react';

export function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already accepted
    const hasAccepted = localStorage.getItem('cookie-consent');
    if (!hasAccepted) {
      // Small delay to prevent flash during page load
      const timer = setTimeout(() => {
        setShowConsent(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'true');
    setShowConsent(false);
  };

  return (
    <AnimatePresence>
      {showConsent && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{
            duration: 0.3,
            ease: 'easeOut',
          }}
          className="fixed bottom-0 left-0 right-0 p-4 z-[100] bg-gradient-to-t from-background/80 to-transparent backdrop-blur-sm"
        >
          <Card className="mx-auto max-w-2xl shadow-lg border-primary/20">
            <CardContent className="p-4 sm:p-6">
              <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
                <div className="flex items-center gap-3">
                  <Cookie className="h-5 w-5 text-muted-foreground shrink-0" />
                  <p className="text-sm text-center sm:text-left text-muted-foreground">
                    We use essential cookies to make our site work. By continuing to use this site, you agree to our use
                    of cookies.
                  </p>
                </div>
                <Button onClick={acceptCookies} className="shrink-0 w-full sm:w-auto animate-in fade-in-0 zoom-in-95">
                  Got it
                </Button>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
